module.exports = __webpack_public_path__ + "static/media/signature.64adff52.png";